import React from 'react';

function noNav(e) {
  e.preventDefault();
}

function LinksDemoComponent() {
  return (
    <div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>Breadcrumb</div>
        <div className='breadcrumb'>
          <a
            href='#/'
            onClick={noNav}
          >
            Operations
          </a>
          <i className='fa-solid fa-chevron-right' />
          <a
            href='#/'
            onClick={noNav}
          >
            Shops
          </a>
          <i className='fa-solid fa-chevron-right' />
          <span>Shop 1234</span>
        </div>
      </div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>Row ID link / data cell link</div>
        <span className='id-link'>#10432</span>
        <span className='secondarylink'>Demo Client Kft.</span>
      </div>
    </div>
  );
}

export const linksDemo = {
  id: 'links',
  title: 'Links',
  category: 'Basics',
  importPath: 'src/Css/design-system/bravo-ds.css (.id-link / .secondarylink / .breadcrumb a)',
  notes: [
    '.id-link: navy 800-weight tabular-nums ID link used in grid rows; hovers red with underline.',
    '.secondarylink: legacy clickable data-cell text, mirrors .id-link.',
    'Breadcrumb links live inside .breadcrumb; Bootstrap also defines .breadcrumb — the margin collision is already neutralized in bravo-app.css.',
  ],
  snippet: "<span className='id-link' onClick={() => openDetail(item.Id)}>#{item.Id}</span>",
  render: LinksDemoComponent,
};
